import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TwofauiComponent } from './twofa-ui.component';
import { AngularMaterialModule } from '../../angular-material/angular-material.module';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [TwofauiComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule
  ],
  exports:[TwofauiComponent]
})
export class TwofauiModule { }
